import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes, faUpRightFromSquare } from '@fortawesome/free-solid-svg-icons';
import PatientCard from '../Patients/PatientCard';
import AdmissionCard from '../Admissions/AdmissionCard';
import '../../styles/ReportEntityDrawer.css';

const ReportEntityDrawer = ({ target, onClose }) => {
  useEffect(() => {
    if (!target) return undefined;
    const onKeyDown = (event) => {
      if (event.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', onKeyDown);
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.removeEventListener('keydown', onKeyDown);
      document.body.style.overflow = previousOverflow;
    };
  }, [target, onClose]);

  if (!target) return null;

  const fullPagePath = target.type === 'patient'
    ? target.fullPagePath
    : `/admission-card?admissionId=${encodeURIComponent(target.admissionId)}`;

  return (
    <div className="report-drawer-backdrop" onClick={onClose} role="presentation">
      <aside
        className="report-drawer"
        role="dialog"
        aria-modal="true"
        aria-label={target.type === 'patient' ? 'Patient details' : 'Admission details'}
        onClick={(event) => event.stopPropagation()}
      >
        <header className="report-drawer-header">
          <h2>{target.type === 'patient' ? 'Patient' : 'Admission'}</h2>
          <div className="report-drawer-actions">
            <Link className="report-drawer-fullpage" to={fullPagePath} title="Open full page">
              <FontAwesomeIcon icon={faUpRightFromSquare} />
              <span>Open full page</span>
            </Link>
            <button type="button" className="report-drawer-close" onClick={onClose} title="Close">
              <FontAwesomeIcon icon={faTimes} />
            </button>
          </div>
        </header>
        <div className="report-drawer-body">
          {target.type === 'patient' ? (
            <PatientCard
              key={`patient-${target.patientId || target.patientNumber}`}
              patientId={target.patientId}
              patientNumber={target.patientNumber}
            />
          ) : (
            <AdmissionCard
              key={`admission-${target.admissionId}`}
              admissionId={target.admissionId}
            />
          )}
        </div>
      </aside>
    </div>
  );
};

export default ReportEntityDrawer;
